import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["label", "item"]
  static values = { club: String, scope: String }

  connect() {
    if (!this.hasLabelTarget) return

    const saved = window.sessionStorage.getItem(this.storageKey())
    if (!saved) return

    const item = this.itemTargets.find((element) => element.dataset.teamId === saved)
    if (item) this.apply(item)
  }

  select(event) {
    event.preventDefault()
    this.apply(event.currentTarget)
  }

  apply(item) {
    const teamId = item.dataset.teamId || ""

    this.labelTarget.textContent = teamId ? item.textContent.trim() : this.labelTarget.dataset.defaultLabel
    this.itemTargets.forEach((element) => {
      element.classList.toggle("active", element === item)
    })

    this.element.querySelectorAll("[data-calendar-event]").forEach((node) => {
      const ids = (node.dataset.teamIds || "").split(",").filter(Boolean)
      node.classList.toggle("d-none", teamId !== "" && !ids.includes(teamId))
    })

    let anyVisible = false

    this.element.querySelectorAll("[data-team-filter-section]").forEach((section) => {
      const events = section.querySelectorAll("[data-calendar-event]")
      const sectionVisible = Array.from(events).some((node) => !node.classList.contains("d-none"))
      section.classList.toggle("d-none", events.length > 0 && !sectionVisible)
      if (sectionVisible) anyVisible = true

      if (section.dataset.teamFilterSection === "upcoming") {
        const heading = this.element.querySelector("[data-team-filter-heading]")
        if (heading) heading.classList.toggle("d-none", events.length > 0 && !sectionVisible)
      }
    })

    const empty = this.element.querySelector("[data-team-filter-empty]")
    if (empty) empty.classList.toggle("d-none", anyVisible)

    if (teamId) {
      window.sessionStorage.setItem(this.storageKey(), teamId)
    } else {
      window.sessionStorage.removeItem(this.storageKey())
    }
  }

  storageKey() {
    const scope = this.scopeValue || "calendar"
    return `${scope}-team-${this.clubValue || "default"}`
  }
}
